'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _investorOrderBy = require('./investorOrderBy.html');

var _investorOrderBy2 = _interopRequireDefault(_investorOrderBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var investorOrderBy = {

    bindings: {
        sortOrder: '<',
        onSort: '&'
    },

    template: _investorOrderBy2.default,

    controller: function controller($scope, $state) {
        var _this = this;

        this.sortDirection = false;
        this.sortDirectionText = 'DESC';

        this.investorSortOrders = {
            'aum': 'AUM',
            'investorName': 'INVESTOR_ACCOUNT'
        };

        /*----------  Sorting order  ----------*/
        this.sort = function () {
            if (!angular.isUndefined(_this.sortOrder)) {
                _this.sortDirection = !_this.sortDirection;
                _this.sortDirectionText = _this.sortDirection ? 'ASC' : 'DESC';
                _this.onSort({ sortOrder: _this.sortOrder, sortDirection: _this.sortDirection });
            }
        };
    }
};

exports.default = investorOrderBy;


/** WEBPACK FOOTER **
 ** ./src/app/directives/investorOrderBy/investorOrderBy.js
 **/